import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ActionReasonModel} from "../../models/action-reason.model";
import {ActionReasonEntityEnum} from "../../enums/action-reason-entity.enum";
import {ActionReasonsDialogsServiceService} from "../../services/action-reasons-dialogs-service.service";
import {ActionReasonsServiceService} from "../../services/action-reasons-service.service";


export class ActionReasonsViewComponent implements IController {

  actionReasons: ActionReasonModel[];
  selectedEntity: ActionReasonEntityEnum;
  actions: any;

  public actionReasonsByEntity: ActionReasonModel[];
  public actionReasonEntityType: typeof ActionReasonEntityEnum = ActionReasonEntityEnum;

  constructor(private actionReasonsDialogsService: ActionReasonsDialogsServiceService, private actionReasonsService: ActionReasonsServiceService) {
  }

  $onInit() {
    this._getActionReasonsByEntity(this.selectedEntity);
  }

  $onChanges(changes) {
    if (changes.actionReasons && !changes.actionReasons.isFirstChange()) {
      this._getActionReasonsByEntity(this.selectedEntity);
    }
    if (changes.selectedEntity && !changes.selectedEntity.isFirstChange()) {
      this._getActionReasonsByEntity(this.selectedEntity);
    }
  }

  onTabSelect(entity: ActionReasonEntityEnum) {
    if (this.selectedEntity !== entity) {
      this.selectedEntity = entity;
      this._getActionReasonsByEntity(this.selectedEntity);
    }
  }

  onCreateActionReason($event) {
    this.actionReasonsDialogsService.createActionReason(this.actions, this.selectedEntity, $event)
      .then((actionReason: ActionReasonModel) => {
        this._createActionReason(actionReason)
      })
  }

  onUpdateActionReason(actionReason: ActionReasonModel, $event) {
    this.actionReasonsDialogsService.updateActionReason(this.actions, actionReason, $event)
      .then((updatedActionReason) => {
        this._updateActionReason(updatedActionReason)
      })
  }

  onDeleteActionReason(actionReasonId: string, $event) {
    this.actionReasonsService.deleteActionReason(actionReasonId)
      .then((removedActionReason: ActionReasonModel) => {
        _.remove(this.actionReasons, (reason: any) => {
          return reason.id == removedActionReason.id;
        });
        this._getActionReasonsByEntity(this.selectedEntity);
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _createActionReason(actionReason: ActionReasonModel) {
    this.actionReasonsService.createActionReason(actionReason)
      .then((createdActionReason) => {
        this.actionReasons.push(createdActionReason);
        this.$onInit();
      })
  }

  private _updateActionReason(updatedActionReason: ActionReasonModel) {
    this.actionReasonsService.updateActionReason(updatedActionReason)
      .then((actionReason: ActionReasonModel) => {
        const actionReasonId = _.findIndex(this.actionReasons, (cr) => {
          return cr.id == actionReason.id;
        })
        this.actionReasons.splice(actionReasonId, 1, actionReason);
        this._getActionReasonsByEntity(this.selectedEntity);
      })
  }

  _getActionReasonsByEntity(entity: ActionReasonEntityEnum) {
    this.actionReasonsByEntity = _.filter(this.actionReasons, (cr) => {
      return cr.entityType === entity;
    })
  }

}

angular
  .module('bringoz.admin.action-reasons')
  .component('actionReasonsView', {
    bindings: {
      actionReasons: '<',
      selectedEntity: '<',
      actions: '<'
    },
    template: require('./action-reasons-view.html').default,
    controller: ActionReasonsViewComponent
  });
